import {createContext, useEffect, useState} from 'react';
import api from '@/lib/api';
export const EmployeeSceneContext = createContext(null);

export function useEmployeeSceneState(userId, scene, enabled = true) {
  const [wide, setWide] = useState(() => window.matchMedia('(min-width: 1101px)').matches);
  const [value, setValue] = useState(null);
  const [revision, setRevision] = useState(0);
  const retry = () => setRevision(n => n + 1);
  const canLoad = enabled && (wide || scene === 'career');
  useEffect(() => {
    const media = window.matchMedia('(min-width: 1101px)');
    const update = () => setWide(media.matches);
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, []);
  useEffect(() => {
    setValue(null);
    if (!canLoad || !userId) return;
    let active = true;
    const controller = new AbortController();
    api.get(`/gamification/scene/${scene}`, {params:{user_id:userId,variant:scene==='home'?'master-v3':'compact-v3',desktop:wide}, signal:controller.signal})
      .then(async ({data}) => {
        const asset = data?.scene;
        const legacy = asset?.layout === 'integrated-v1' && asset.width === 1586 && asset.height === 992;
        const master = scene === 'home' && asset?.height === 821 && ((asset.layout === 'home-master-v2' && asset.width === 1915) || (asset.layout === 'home-master-v3' && asset.width === 1916));
        const prestige = scene === 'career' && asset?.layout === 'career-prestige-v2' && asset.width === 1586 && asset.height === 992;
        const emptyStage = asset?.neutral_scene === true && asset?.embedded_avatar === false &&
          ((scene === 'home' && asset.layout === 'home-master-v3' && asset.width === 1916 && asset.height === 821) ||
           (scene === 'career' && asset.layout === 'career-compact-v3' && asset.width === 1672 && asset.height === 941));
        if (data?.user_id !== userId || !(legacy || master || prestige || (scene==='career' && asset?.layout==='career-compact-v3' && asset.width===1672 && asset.height===941)) ||
            !(asset?.embedded_avatar === true || emptyStage) || !asset?.data_url?.startsWith('data:image/webp;base64,')) throw new Error('No current employee scene');
        const image = new Image(); image.src = asset.data_url;
        await image.decode();
        if (active) setValue({userId, scene, asset, desktop:wide});
      }).catch(() => {if(active)setValue({userId,scene,desktop:wide,asset:null,error:true});});
    return () => {active = false; controller.abort();};
  }, [userId, scene, canLoad, wide, revision]);
  const current = canLoad && value?.userId === userId && value?.scene === scene && value?.desktop === wide ? value : null;
  return {asset:current?.asset || null, loading:canLoad && !!userId && !current, error:!!current?.error, wide, retry};
}

export default function useEmployeeScene(userId,scene,enabled=true){return useEmployeeSceneState(userId,scene,enabled).asset;}
